import PointLeaflet from "./PointLeaflet";

export default PointLeaflet;
